import React from 'react';
import { ConfigConsumer } from '../config-provider';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import enUS from './locale/en_US';
import classNames from 'classnames';
export default class FtContainer extends React.Component {
    constructor() {
        super(...arguments);
        this.renderContainer = ({ getPrefixCls }) => {
            const { prefixCls: customizePrefixCls } = this.props;
            const prefixCls = getPrefixCls('container', customizePrefixCls);
            const containerCls = classNames(prefixCls);
            return (<LocaleReceiver defaultLocale={this.getDefaultLocale} componentName="FtContainer">
            {(mergedLocale) => {
                mergedLocale.lang;
                return (<div className={`${containerCls}`} style={this.props.style}>
                    
                    <div className={`${prefixCls}--bg`}>{this.props.bg}</div>
                    <div className={`${prefixCls}--content`}>{this.props.con}</div>
                </div>);
            }}
        </LocaleReceiver>);
        };
        this.getDefaultLocale = () => {
            const { locale } = this.props;
            const result = Object.assign(Object.assign({}, enUS), locale);
            result.lang = Object.assign(Object.assign({}, result.lang), (locale || {}).lang);
            return result;
        };
    }
    render() {
        return (<ConfigConsumer>
                {this.renderContainer}
            </ConfigConsumer>);
    }
}
